const NotFound = () => {
    const baseUrl = process.env.REACT_APP_BASEURL;
    return <main>
        <div className="container">
            <section className="section error-404 min-vh-100 d-flex flex-column align-items-center justify-content-center">
                <h1 style={{ fontSize: "160px" }}>404</h1>
                <h2>The page you are looking for doesn't exist.</h2>
                <a className="btn btn-primary" href="/home">Back to home</a>
                <img style={{ width: "200px" }} src={`${baseUrl}/assets/img/not-found.svg`} className="img-fluid py-5" alt="Page Not Found" />
                <div className="credits">
                    Designed by <a href="/">PUSDATIN</a>
                </div>
            </section>
        </div>
    </main>
}
export default NotFound